<template>
  <Content title="中国领先的的政采供应商" class="bg-white">
    <div class="leading-supplier d-flex justify-content-between text-center th-pt-48">
      <div
        v-for="(advantage, i) in advantages"
        :key="i"
        class="advantage-item bg-white d-flex flex-column align-items-center"
      >
        <img class="advantage-icon d-block" :src="advantage.image" />
        <div class="th-fs-28 lh-1 fw-bold th-mt-23">{{ advantage.title }}</div>
        <div class="th-fs-16 th-mt-27 advantage-desc">{{ advantage.desc }}</div>
      </div>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
import { advantages } from './data'
export default {
  name: 'DesktopLeadingSupplier',
  components: { Content },
  setup() {
    return { advantages }
  },
}
</script>

<style lang="scss" scoped>
.advantage-item {
  width: 230px;
}

.advantage-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.advantage-desc {
  color: #333333;
}
</style>
